import {
  SelectedTab,
  useConfiguracoesController,
} from './useConfiguracoesController'
import { BannersPage } from './BannersPage/BannersPage'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/view/components/TabsTable'
import { ConfigsPage } from './ConfigsPage'
import { useAuth } from '@/app/hooks/useAuth'
import { FormProvider } from 'react-hook-form'
import { AddTableCard } from './TablePage/components/AddTableCard'
import { useMemo } from 'react'
import PartnersPage from './PartnersPage'

export const Configuracoes = () => {
  const { selectedTab, setSelectedTab, methods } = useConfiguracoesController()

  const { isSuperAdmin } = useAuth()

  const handleChangeTab = (tab: string) => {
    setSelectedTab(tab as SelectedTab)
  }

  const tabs = useMemo(() => {
    const base = []
    if (isSuperAdmin) {
      base.push({ value: 'configs', label: 'Geral', content: <ConfigsPage /> })
    }
    base.push({ value: 'products', label: "Produtos", content: <PartnersPage /> })
    base.push({ value: 'banner', label: 'Banners', content: <BannersPage /> })

    handleChangeTab(base[0].value)
    return base
  }, [isSuperAdmin])

  return (
    <Tabs
      defaultValue={selectedTab}
      value={selectedTab}
      onValueChange={handleChangeTab}
    >
      <div className="flex items-center justify-between">
        <TabsList className=" mb-8 mt-4 flex items-center gap-8">
          {tabs.map(({ label, value }) => (
            <TabsTrigger key={value} className="text-xl" value={value}>
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {selectedTab === 'table' && (
          <FormProvider {...methods}>
            <AddTableCard />
          </FormProvider>
        )}
      </div>
      {tabs.map(({ value, content }) => (
        <TabsContent value={value} key={value}>
          {content}
        </TabsContent>
      ))}
    </Tabs>
  )
}
